import { VirusScanStatus } from 'hb-react/shared/hooks/useGlobalStorageV2/constants';
import { type GlobalStorageFile } from 'hb-react/shared/hooks/useGlobalStorageV2/types';

export const isGSFileScanned = (storedFile: GlobalStorageFile) =>
  // "attached" files are assumed to be scanned already.
  storedFile.storageStatus === 'attached' ||
  (!!storedFile.virusScanStatus &&
    [
      VirusScanStatus.CLEAN,
      VirusScanStatus.INFECTED,
      VirusScanStatus.NOT_SCANNABLE,
    ].includes(storedFile.virusScanStatus));
